/**
 * Charge une matiere dans le configurateur present sur la page.
 *
 * Sert au nuancier comme aux cartes « Nouveautes » : partout ou un visuel de
 * matiere doit renvoyer au configurateur plutot qu'a la fiche produit.
 *
 * Progressif. Les elements enveloppes sont d'abord des liens vers la variante :
 * sans JS, ou sur une page sans configurateur, le clic mene a la fiche produit
 * deja configuree et rien n'est perdu. Le composant ne detourne le clic que
 * lorsqu'il trouve, dans la meme page, le radio correspondant.
 *
 * Il ne reimplemente rien de la selection de variante : il declenche un vrai
 * clic sur le radio, donc VariantSelects prend le relais exactement comme si
 * le visiteur avait clique la pastille, avec sa mise a jour par la Section
 * Rendering API.
 */
class GoConfiguratorLink extends HTMLElement {
  connectedCallback() {
    this.onClick = this.onClick.bind(this);
    this.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
  }

  onClick(event) {
    // Un clic modificateur ouvre un onglet : c'est une intention de navigation,
    // on la laisse passer plutot que de la transformer en selection.
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;

    const source = event.target.closest('[data-option-value-id]');
    if (!source || !this.contains(source)) return;

    const input = document.querySelector(
      `input[data-option-value-id="${CSS.escape(source.dataset.optionValueId)}"]`
    );
    if (!input) return;

    event.preventDefault();

    // La cible du defilement est relevee avant le clic : la selection redessine
    // le configurateur, et la reference au conteneur ne survivrait pas au
    // remplacement de son contenu.
    const target = input.closest('.shopify-section') || input;

    // L'etape 1 masque les familles non ouvertes : sans cela, la valeur serait
    // bien cochee mais invisible.
    const steps = input.closest('go-config-steps');
    const group = input.closest('.go-group[data-family]');
    if (steps && group && group.dataset.family) steps.apply(group.dataset.family);

    input.click();

    // Defilement anime partage avec le CTA du hero (`go-smooth-scroll.js`) :
    // Chrome annulerait un `scrollIntoView` anime sous « reduire les
    // animations », et la remontee vers le configurateur se ferait d'un bloc,
    // sans qu'on voie d'ou l'on vient.
    const destination = target.getBoundingClientRect().top + window.scrollY;
    if (window.goSmoothScrollTo) {
      window.goSmoothScrollTo(destination);
    } else {
      target.scrollIntoView({ block: 'start' });
    }
  }
}

// Deux sections chargent ce fichier, et elles coexistent sur l'accueil : le
// nuancier et les Nouveautes emettent chacune leur balise <script src>. Deux
// balises identiques s'executent deux fois — une seule requete, deux passages —
// donc sans cette garde le second redefinit un nom deja pris et leve une
// exception. Convention de Dawn, qui protege ainsi tous ses composants.
if (!customElements.get('go-configurator-link')) {
  customElements.define('go-configurator-link', GoConfiguratorLink);
}
